const REWARDS_CONSTANTS = {
  GETTING_REFERRAL_DATA: 'GETTING_REFERRAL_DATA',
  GET_REFERRAL_DATA_SUCCESS: 'GET_REFERRAL_DATA_SUCCESS',
  GET_REFERRAL_DATA_FAILURE: 'GET_REFERRAL_DATA_FAILURE'
};
export default REWARDS_CONSTANTS;
